import React from 'react';
import PropTypes from 'prop-types';
import suitcss from '../../../helpers/suitcss';

function SliderSlide({ modifiers, hideFromTab, children }) {
  return (
    <div
      className={suitcss({
        componentName: 'Slider',
        descendantName: 'slide',
        className: 'swiper-slide',
        modifiers,
      })}
      inert={hideFromTab ? '' : undefined} // necessary because inert doesn't support booleans in this React version.
      tabIndex={hideFromTab ? -1 : undefined}
    >
      {children}
    </div>
  );
}

SliderSlide.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array,
  ]),
  modifiers: PropTypes.array,
  hideFromTab: PropTypes.bool,
};

SliderSlide.defaultProps = {};

export default SliderSlide;
